<script>
import AgoraRTC from 'agora-rtc-sdk-ng'
import failStrongIcon from '../assets/failstrong.svg'
import 'element-ui/lib/theme-chalk/select.css'
import 'element-ui/lib/theme-chalk/option.css'

import {
  getDefaultCameraId,
  setDefaultCameraId
} from '../helper/deviceDetect.helper'

export default {
  data: () => {
    return {
      isDetectFinish: false,
      isFail: false,
      failTip: '',
      localVideoTrack: null,
      failStrongIcon,
      deviceId: getDefaultCameraId()
    }
  },
  methods: {
    async openVideo() {
      if (this.localVideoTrack) {
        this.localVideoTrack.close()

        const playerBox = document.getElementById('web-camera-player')
        if (playerBox) {
          playerBox.innerHTML = ''
        }
      }
      AgoraRTC.createCameraVideoTrack({
        cameraId: this.deviceId
      })
        .then((track) => {
          const playerBox = document.getElementById('web-camera-player')
          if (!playerBox) {
            track.setEnabled(false)
            track.close()
            return
          }

          this.localVideoTrack = track
          this.localVideoTrack.play('web-camera-player')
          this.$emit('detect-finsh', true)
        })
        .catch((err) => {
          console.log('err', err)
          this.$emit('detect-finsh', false)
          const handelErr = (err) => {
            console.error('打开摄像头失败', err)
            this.isFail = true
            switch (err.code) {
              case 'NotAllowedError':
                this.$message.error('请允许访问摄像头')
                this.failTip = '请允许访问摄像头'
                break
              case 'MEDIA_OPTION_INVALID':
                this.$message.error('摄像头被占用或者分辨率不支持')
                this.failTip = '摄像头被占用或者分辨率不支持'
                break
              case 'DEVICES_NOT_FOUND':
                this.$message.error('没有找到设备')
                this.failTip = '没有找到设备'
                break

              case 'NOT_SUPPORTED':
                this.$message.error('浏览器不支持获取获取摄像头和麦克风')
                this.failTip = '浏览器不支持获取获取摄像头和麦克风'
                break

              case 'PERMISSION_DENIED':
                this.$message.error('浏览器禁用设备或者用户拒绝打开设备')
                this.failTip = '浏览器禁用设备或者用户拒绝打开设备'
                break

              case 'CONSTRAINT_NOT_SATISFIED':
                this.$message.error('配置参数不合法')
                this.failTip = '配置参数不合法'
                break

              case 'PluginNotInstalledProperly':
                this.$message.error(
                  '用户尝试在 Chrome 上进行屏幕共享，但未安装屏幕共享插件，或使用了错误的 extensionId'
                )
                this.failTip =
                  '用户尝试在 Chrome 上进行屏幕共享，但未安装屏幕共享插件，或使用了错误的 extensionId'
                break

              case 'UNDEFINED':
                this.$message.error('摄像头打开失败')
                this.failTip = '摄像头打开失败'
                break
            }
          }
          handelErr(err)
        })
        .finally(() => {
          this.isDetectFinish = true
        })
    },
    openHelpLink() {
      window.open('https://education.codemao.cn/27/contest/1/配置摄像头监控.pdf')
    }
  },
  watch: {
    deviceId() {
      if (this.localVideoTrack) {
        this.openVideo()
      }
      if (this.deviceId) {
        setDefaultCameraId(this.deviceId)
      }
    }
  },
  mounted() {
    this.openVideo()
  },
  destroyed() {
    if (this.localVideoTrack) {
      this.localVideoTrack.close()
      const playerBox = document.getElementById('web-camera-player')
      if (playerBox) {
        playerBox.innerHTML = ''
      }
    }
  }
}
</script>
<template>
  <div class="web-camera-detect-wrapper">
    <div class="guilde-text-wrapper">
      <p>监控要求：1、头部位于摄像框内；2、身边没人；3、房间,</p>
      <p>
        光线明亮， 不背光不反光。详细图文说明
        <span @click="openHelpLink" class="guide-btn">点此查看>></span>
      </p>
    </div>

    <div class="web-camera-player-wrapper">
      <div id="web-camera-player" class="web-camera-player"></div>
      <p v-if="!isDetectFinish" class="not-open-tip">未接入摄像头</p>
      <div v-if="isFail" class="fail-tip-box">
        <img
          :src="failStrongIcon"
          style="width: 18px; margin-right: 8px; margin-top: -2px"
          alt="fail"
        />
        <p>{{ failTip }}</p>
      </div>
      <img class="manface-canny" v-if="isDetectFinish && !isFail" src="@/assets/images/detect/manface-tip.png" alt="face" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.web-camera-detect-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 64px;

  .web-camera-player-wrapper {
    margin-top: 16px;
    width: 320px;
    height: 180px;
    overflow: hidden;
    position: relative;
    .not-open-tip {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13.55px;
      line-height: 18.97px;
      letter-spacing: 0px;
      text-align: center;
      color: #4a5578;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .fail-tip-box {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13.55px;
      line-height: 13.55px;
      letter-spacing: 0px;
      text-align: center;
      width: 100%;
      color: #ff5858;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .web-camera-player {
    width: 320px;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    background-color: #eceef6;
    /deep/ video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .manface-canny {
    width: 135px;
    height: 140px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
